// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddCompanyBlock-module--wrapper--H92qI","newStyle":"AddCompanyBlock-module--newStyle--JFicA","imageBlock":"AddCompanyBlock-module--imageBlock--uPZdC"};